import type { Observable } from 'rxjs';
import type { Domain } from '@common/types/domain.type';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { getDomainHandler, getFullDomainNameHandlerWithProtocol } from '@common/helpers/domains';

import * as DomainsSelectors from './domains.selectors';
import DomainsActions from './domains.actions';

@Injectable()
export class DomainsFacade {
    private readonly store = inject(Store);

    public readonly domains$: Observable<Domain[]> = this.store.select(DomainsSelectors.selectDomains);

    public loadDomains(siteId: string): void {
        this.store.dispatch(DomainsActions.loadDomainsRequest({ siteId }));
    }

    public get siteDomainUrlWithProtocol$(): Observable<string> {
        return this.domains$.pipe(map((domains) => getFullDomainNameHandlerWithProtocol(domains)));
    }

    public get siteDomain$(): Observable<Domain | null> {
        return this.domains$.pipe(map((domains) => getDomainHandler(domains)));
    }
}
